import { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { CheckCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { CustomButton } from '../../../../../components/CustomButton'
import WMSTipoOSService from '../../../../../services/database/WMSTipoOSService'
import { sendErrorApiMessage } from '../../../../../utils/sendErrorApiMessage'

export function ModalCreate({ isOpen, onClose, loadTipos }) {
  const [descricao, setDescricao] = useState('')
  const [isCreateRequestLoading, setIsCreateRequestLoading] = useState(false)

  async function handleCreateTipo() {
    try {
      setIsCreateRequestLoading(true)

      await WMSTipoOSService.create({ descricao })

      loadTipos()
      toast.success('Tipo criada com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao criar o tipo!')
    } finally {
      setIsCreateRequestLoading(false)
      onClose()
    }
  }

  function resetStates() {
    setDescricao('')
    setIsCreateRequestLoading(false)
  }

  useEffect(() => {
    resetStates()
  }, [])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header>
        <Modal.Title>Cadastrar Tipo</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
          placeholder="Descrição..."
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              if (e.target.value) {
                handleCreateTipo()
              }
            }
          }}
        />
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          isDisabled={!descricao}
          title="Cadastrar"
          color="#0d9a04"
          onClick={handleCreateTipo}
          isLoading={isCreateRequestLoading}
          isLoadingText="Cadastrando..."
        >
          <CheckCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
